import { Box, Typography } from '@mui/material';

export interface DetailFieldProps {
  /** Field label (translated). */
  label: string;
  /** Field value. Empty/nullish values render the placeholder. */
  value?: string | null;
  /** Shown when the value is empty. Defaults to an em dash. */
  placeholder?: string;
}

/**
 * A label/value pair for detail pages. Replaces the local `Field` helper that
 * was duplicated in PersonDetailPage and CompanyDetailPage (issue #881).
 */
export function DetailField({ label, value, placeholder = '—' }: DetailFieldProps) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2">{value && value.length > 0 ? value : placeholder}</Typography>
    </Box>
  );
}
